// The account's backend for the player's disk (@moonbase-machines/player/disk/disk.js says what a backend is): a
// disk's files kept on the account, by the site's API (/api/disk/, functions/api/disk/), behind the same calls as
// this browser's IndexedDB (disk/local.js) and memory (disk/memory.js). The provider (web/provider.js) chooses it when
// a visit is signed in; nothing in the package knows of it. A call that fails throws, and the disk says so (`failed`).
//
//   api({ base })   a backend: { kept, where, load(disk), put(disk, file), delete(disk, name) }
const fromB64 = text => Uint8Array.from(atob(text), c => c.charCodeAt(0));
export const WHERE = 'your account';

export function api({ base = '/api/disk/' } = {}) {
  const at = (disk, name) => `${base}${disk}${name === undefined ? '' : '/' + encodeURIComponent(name)}`;
  const answer = async (r, what) => { if (!r.ok) { let why = ''; try { why = (await r.json()).error ?? ''; } catch {} throw new Error(`${what}: ${r.status}${why ? ', ' + why : ''}`); } return r; };
  return {
    kept: true, where: WHERE,
    load: async disk => (await (await answer(await fetch(at(disk), { cache: 'no-store' }), `${disk}: not loaded`)).json()).files
      .map(f => ({ name: f.name, bytes: fromB64(f.bytes), meta: f.meta ?? {}, modified: f.modified })),
    put: async (disk, f) => { await answer(await fetch(at(disk, f.name), { method: 'PUT', body: f.bytes, headers: { 'content-type': 'application/octet-stream', 'x-meta': JSON.stringify(f.meta ?? {}), 'x-modified': String(f.modified ?? Date.now()) } }), `${disk}: ${f.name} not kept`); },
    delete: async (disk, name) => { await answer(await fetch(at(disk, name), { method: 'DELETE' }), `${disk}: ${name} not removed`); },
  };
}
